const translations = {
  info: 'Info',
  price_and_costs: 'Price & costs',
  marketing: 'Marketing',
  media: 'Media',
  forms: 'Forms',
  analytics: 'Analytics',
  docs: 'Documents',
  other_docs: 'Other documents',

  expire: 'Expire',
  activate: 'Activate',
  download_daco: 'Download DACO',
  download_warranty: 'Download Warranty & Conditions',
  sell_vehicle: 'Sell vehicle',

  vehicle_status: 'Vehicle status',
  total_impressions: 'Total impresisons',
  total_views: 'Total views',
  days_in_stock: 'Days in stock',
  generated_leads: 'Generated leads',
  estimated_revenue: 'Est. revenue',

  vehicle_title: 'Vehicle',
  vehicle_description:
    'Enter the basic dealer information. Keep it updated to maximize sales opportunities.',

  inventory_title: 'Inventory',
  inventory_description:
    'Important information about the condition, location and documents of the vehicle.',

  documentation_title: 'Documentation',
  documentation_description:
    'Keep these records updated to ensure compliance and streamline the sales process.',

  vin: 'VIN',
  vin_placeholder: 'Enter VIN',
  select_vin: 'Select VIN',
  loading_vin_list: 'Loading VIN list...',
  invalid_vin: 'Invalid VIN',
  remove_vin: 'Remove VIN',
  remove_vin_description: 'Are you sure you want to remove VIN?',

  restore_vin_info: 'Restore VIN Information',
  restore_vin_data: 'Restore VIN data',
  restore_vin_info_description: 'Are you sure you want to restore VIN information?',
  vin_info_restored: 'VIN information restored successfully',
  vin_decoder: 'Vin decoder',

  replace_vin: 'Replace VIN',
  replace_vin_description:
    'Existing information will be replaced with the new VIN. What do you want to do with the existing images?',
  replace_vin_description_no_media:
    'Existing information will be replaced with the new VIN information.',
  vin_already_exists: 'The VIN is already in use',

  make: 'Make',
  make_placeholder: 'Enter Make',
  invalid_make: 'Invalid Make',

  model: 'Model',
  model_placeholder: 'Enter Model',
  invalid_model: 'Invalid Model',

  trim: 'Trim',
  trim_placeholder: 'Enter trim',
  invalid_trim: 'Invalid trim',

  year: 'Year',
  year_placeholder: 'Enter year',
  invalid_year: 'Invalid year',

  condition: 'Condition',
  condition_placeholder: 'Enter condition',
  invalid_condition: 'Invalid condition',
  new: 'New',
  used: 'Used',
  all: 'All',
  none: 'None',

  type: 'Type',
  type_placeholder: 'Enter Type',
  invalid_type: 'Invalid Type',

  mileage: 'Mileage',
  mileage_placeholder: 'Enter Mileage',
  invalid_mileage: 'Invalid Mileage',

  engine: 'Engine',
  engine_placeholder: 'Enter Engine',
  invalid_engine: 'Invalid Engine',

  transmission: 'Transmission',
  transmission_placeholder: 'Enter Transmission',
  invalid_transmission: 'Invalid Transmission',

  drivetrain: 'Drivetrain',
  drivetrain_placeholder: 'Enter Drivetrain',
  invalid_drivetrain: 'Invalid Drivetrain',

  mpg_city: 'MPG City',
  mpg_city_placeholder: 'Enter MPG City',
  invalid_mpg_city: 'Invalid MPG City',

  mpg_highway: 'MPG Highway',
  mpg_highway_placeholder: 'Enter MPG Highway',
  invalid_mpg_highway: 'Invalid MPG Highway',

  ext_color: 'Exterior color',
  int_color: 'Interior color',
  color_placeholder: 'Enter color',
  invalid_color: 'Invalid color',

  stock_number: 'Stock number',
  stock_number_placeholder: 'Enter stock number',
  invalid_stock_number: 'Invalid stock number',

  location: 'Location',
  location_placeholder: 'Enter location',
  invalid_location: 'Invalid location',

  fleet: 'Fleet',
  fleet_placeholder: 'Select fleet',
  invalid_fleet: 'Invalid fleet',

  tag_number: 'Registration sticker',
  tag_number_placeholder: 'Enter registration sticker',
  invalid_tag_number: 'Invalid registration sticker',

  tag_number_expiration_date: 'Registration expiration',
  tag_number_expiration_date_placeholder: 'Enter registration sticker expiration date',
  invalid_tag_number_expiration_date: 'Invalid registration sticker expiration date',

  is_pledged: 'Pledged',
  is_pledged_placeholder: 'Enter pledged',
  invalid_is_pledged: 'Invalid pledged',

  title_holding_institution: 'Title Holding Institution',
  institution_placeholder: 'Enter institution',
  invalid_institution: 'Invalid institution',

  notes: 'Notes',
  notes_placeholder: 'Enter notes',
  invalid_notes: 'Invalid notes',

  source: 'Source',
  featured_label: 'Featured',
  featured_placeholder: 'Enter featured',
  invalid_featured: 'Invalid featured',

  expiration_date: 'Expiration date',
  featured_label_description: 'Marks the vehicle as featured.',

  on_sale: 'On sale',
  on_sale_description: 'Marks the vehicle as a special offer.',

  down_price: 'Down price',
  down_price_description: 'Shows that the vehicle is priced below market value',

  price_drop: 'Price drop',
  price_drop_description: 'Shows that the vehicle has a price drop.',

  discount_coupon: 'Discount coupon',
  discount_coupon_description: 'Shows that the vehicle has a discount bonus.',

  discount_amount: 'Discount amount',
  discount_amount_placeholder: 'Enter discount amount',
  invalid_discount_amount: 'Invalid discount amount',
  current_discount: 'Current discount',
  set_amount: 'Set amount',

  infinite_expiration_date: 'Do not set expiration date',
  expires_on: 'Expires on',
  never: 'Never',

  discount_amount_expiration_date: 'Discount expiration date',
  discount_amount_expiration_date_placeholder: 'Enter discount expiration date',
  invalid_discount_amount_expiration_date: 'Invalid discount expiration date',

  registration_plate_number: 'Licese plate',
  registration_plate_number_placeholder: 'Enter plate number',
  invalid_registration_plate_number: 'Must have a minimum of 6 chars and a maximum of 7',

  is_tune_up: 'Tune up',
  is_tune_up_placeholder: 'Enter tune up',
  invalid_is_tune_up: 'Invalid tune up',

  reception_date: 'Reception date',
  reception_date_placeholder: 'Enter reception date',
  invalid_reception_date: 'Invalid reception date',
  ageing: 'Ageing',
  ageing_placeholder: 'Calculated ageing',

  is_title_in_dealer: 'Title at dealer',
  is_title_in_dealer_placeholder: 'Select title in dealer',
  invalid_is_title_in_dealer: 'Invalid title in dealer',

  title_status: 'Title status',
  title_status_placeholder: 'Select title status',
  invalid_title_status: 'Invalid title status',
  title_status_pending: 'Pending',
  title_status_received: 'Received',
  title_status_in_process: 'In process',
  title_status_held_by_lienholder: 'Held by lienholder',
  title_status_duplicate_requested: 'Duplicate requested',
  title_status_salvage: 'Salvage',
  title_status_rebuild: 'Rebuild',
  title_status_ready_for_transfer: 'Ready for transfer',
  title_status_under_review: 'Under review',

  free_of_lien: 'Lien-free certificate',
  free_of_lien_placeholder: 'Select libre de gravamen',
  invalid_free_of_lien: 'Invalid libre de gravamen',

  status: 'Status',
  status_description:
    'Important information about the condition, location and documents of the vehicle.',

  photos_title: 'Photos',
  photos_description:
    'You can upload up to 20 images per vehicle. Accepted files format are jpg, png, webp.',
  add_image: 'Add image',
  files_upload_success: 'Files uploaded successfully',
  file_upload_success: 'File uploaded successfully',
  file_remove_success: 'File removed successfully',
  add_stock_photos: 'Add stock photos',
  stock_photos: 'Stock photos',
  stock_photo_badge: 'Stock',
  mark_stock_photo: 'Mark as stock',
  unmark_stock_photo: 'Unmark as stock',
  stock_photo_updated: 'Stock photo designation updated',
  stock_photo_update_error: 'Could not update the stock photo designation. Please try again.',
  stock_photos_imported: 'Stock photos imported successfully',
  stock_photos_import_error: 'Failed to import stock photos',
  photo_deleted_successfully: 'Photo deleted successfully',
  photo_delete_error: 'Photo delete error',
  remove_photo: 'Remove photo',
  remove_photo_description: 'Are you sure you want to remove this photo?',
  enhance_image: 'Enhance image',
  enhance_image_question: 'Do you want to enhance the photo quality?',
  enhance_image_original_media: 'Original media',
  enhance_image_enhanced_media: 'Enhanced media',
  enhance_image_before: 'Original',
  enhance_image_after: 'Enhanced',
  enhance_image_processing_failed: 'Image enhancement failed. Please try again.',
  enhance_image_result_error: 'Could not load the enhanced image preview.',
  enhance_image_result_expired: 'The enhanced image preview has expired. Please try again.',
  enhance_image_start_error: 'Could not start image enhancement.',
  enhance_image_upload_sign_error: 'Could not prepare the enhanced image upload.',
  enhance_image_upload_error: 'Could not upload the enhanced image.',
  enhance_image_apply_error: 'Could not apply the enhanced image.',
  enhance_image_applied_successfully: 'Enhanced image applied successfully.',
  enhance_image_source_changed: 'The original image changed. Please refresh and try again.',
  bulk_enhance_selection_limit: 'You can select up to {{limit}} photos for bulk enhancement.',
  bulk_enhance_confirm_title: 'Enhance selected photos',
  bulk_enhance_confirm_description:
    'Do you want to enhance {{count}} selected photos? You can keep working while they are processed.',
  bulk_enhance_confirm_already_enhanced:
    '{{count}} of the selected photos were already enhanced and will be skipped.',
  bulk_enhance_confirm_action: 'Start enhancement',
  bulk_enhance_review: 'Review',
  bulk_enhance_multiple_processes: 'Review media processing ({{count}})',
  bulk_enhance_review_title: 'Review enhanced photos',
  bulk_enhance_review_progress: '{{current}} of {{total}}',
  bulk_enhance_review_empty: 'There are no enhanced photos ready to review.',
  bulk_enhance_apply_all: 'Apply All',
  bulk_enhance_discard_all: 'Discard All',
  bulk_enhance_skipped: '{{count}} photos were skipped because they cannot be enhanced.',
  bulk_enhance_action_error: 'Could not process {{count}} photos. Please try again.',
  bulk_delete_confirm_title: 'Remove selected photos',
  bulk_delete_confirm_description:
    'Are you sure you want to remove {{count}} selected photos? This action cannot be undone.',
  bulk_delete_success: '{{count}} photos deleted successfully',
  bulk_delete_error: 'Could not delete the selected photos. Please try again.',
  bulk_delete_processing_active:
    'Some of the selected photos are being processed and cannot be deleted yet.',
  bulk_delete_invalid_selection:
    'Some of the selected photos are no longer available. Please refresh and try again.',

  video_title: 'Video',
  video_description:
    'You can upload 1 video file or 1 YouTube video link per vehicle. Accepted files format are mp4, mov, mpeg2.',
  add_video: 'Add video',
  video_deleted_successfully: 'Video deleted successfully',

  marketing_title: 'Marketing',
  presentation_title: 'Presentation',
  presentation_description: 'Set a title and description for your shared posts and landing pages.',
  external_pages_title: 'External pages',
  external_pages_description:
    'Set the preferred options that suits best your inventory marketing and sales goals.',
  labels_title: 'Inventory labels',
  labels_description:
    'The labels allow you to manage the visibility and promotion of vehicles in the inventory, making it easier for customers to identify the best opportunities and optimizing their purchasing experience.',
  featured_disabled_by_dealer: 'This option is currently disabled by the dealer',
  label_not_visible: 'Currently not visible',

  title: 'Title',
  title_placeholder: 'Enter title',
  invalid_title: 'Invalid title',

  description: 'Description',
  description_placeholder: 'Enter description',
  invalid_description: 'Invalid description',

  featured: 'Featured on external pages',
  featured_description: 'The vehicle will appear on external sales sites',

  show_price_external: 'Show price on external pages',
  show_price_external_description: 'The price will be visible on external sales sites',

  alliances_can_see: 'Allow alliances to see and search this vehicle',
  alliances_can_see_description: 'The alliances will have access to the vehicle',

  price_title: 'Pricing',
  price_description:
    'Set the pricing information for this vehicle in order to help your customers to make the a better choice.',

  sale_price: 'Sale price',
  price_placeholder: 'Enter price',
  invalid_price: 'Invalid price',

  suggested_price: 'Suggested price',

  sale_terms: 'Terms of sale',
  sale_terms_placeholder: 'Enter terms of sale',
  invalid_sale_terms: 'Invalid terms of sale',
  sale_terms_1: 'Negotiable',
  sale_terms_2: 'Non Negotiable',

  youtube_link: 'YouTube link',
  youtube_link_placeholder: 'Enter YouTube link',
  invalid_youtube_link: 'Invalid YouTube link',
  video_file: 'Video file',
  video_file_placeholder: 'Upload from local drive',

  video_source: 'Video source',
  video_source_placeholder: 'Enter video source',
  invalid_video_source: 'Invalid video source',
  add_file: 'Add file',

  remove_video: 'Remove video',
  remove_video_description: 'Are you sure you want to remove video?',

  no_photos: 'There are no photos uploaded yet',
  no_video: 'There is no video uploaded yet',
  doc_name: 'Name',
  uploaded_at: 'Uploaded at',
  uploaded_by: 'Uploaded by',

  restore_title: 'Restore title',
  restore_title_description: 'Are you sure you want to restore the title?',
  remove_description: 'Remove description',
  remove_description_description: 'Are you sure you want to remove the description?',

  analytics_description:
    'These are the performance statistics of this vehicle within the inventory and on its own page',
  forms_description:
    'Record of forms sent from the sites where the vehicle is displayed. Maintain detailed tracking of inquiries received to maximize sales opportunities.',
  contact_added_at: 'Added at: {{date}}',
  leads: 'Leads',
  leads_description:
    'Track the number of leads generated from a vehicle listing. Use this information to improve lead management and conversion rates.',

  brand: 'Brand',

  file_upload_failed: 'Upload failed',
  file_upload_failed_description:
    'Some images failed to upload. Please check if the images listed below meet the system requirements and try again.',
  all_file_upload_failed_description:
    'All images failed to upload. Please check if the images listed below meet the system requirements and try again.',
  aspect_ratio_error: 'The aspect ratio must be 4:3',
  max_size_exceeded: 'The max. size is 5MB',
  file_upload_failed_reason: 'Upload error',

  other_docs_description:
    'Upload reports and supplementary documentation to keep this information accessible to your team.',
  docs_description:
    'Upload and manage all relevant documents related to the vehicle, ensuring that essential information is easily accessible and up-to-date.',
  add_document: 'Add document',
  view_document: 'View document',
  view_details: 'View details',
  document: 'Document',
  document_placeholder: 'Select document',
  choose_file: 'Choose file',
  remove_document: 'Remove document',
  remove_document_description: 'Are you sure you want to remove the document?',
  document_uploaded: 'Document uploaded successfully',
  document_removed_successfully: 'Document removed successfully',

  doors: 'Doors',
  doors_placeholder: 'Enter doors',
  invalid_doors: 'Invalid doors option',

  basic: 'Basic',
  extended_info: 'Extended info',
  vehicle: 'Vehicle',
  acquisition: 'Acquisition',

  visibility: 'Visibility',
  visibility_internal: 'Internal',
  visibility_public: 'Public',
  alliances_visibility: 'Alliances Visibility',
  share_with_alliances: 'Share with alliances',
  dont_share_with_alliances: "Don't share with alliances",

  analytics_impressions: 'Impressions',
  analytics_impressions_description:
    'Monitor the number of times a vehicle has been viewed across various platforms where it is listed. Use this data to assess the effectiveness of your listings and marketing efforts.',
  analytics_views: 'Views',
  analytics_views_description:
    'Track the number of views a vehicle has received on different platforms. Utilize this information to gauge interest and adjust your marketing strategy accordingly.',
  analytics_featured: 'Featured',
  analytics_featured_description:
    'Analyze the number of impressions a vehicle has garnered when featured on different sites. Leverage this data to enhance the visibility and appeal of your listings.',
  analytics_forms: 'Forms',
  analytics_forms_description:
    'Record the number of contact forms submitted for a vehicle. This helps in measuring customer interest and responsiveness, aiding in follow-up and customer service efforts.',

  form: 'Form',
  date: 'Date',
  invoice_date: 'Invoice date',
  created_at: 'Created at',
  from: 'From',
  lead: 'Lead',
  email: 'Email',
  trade_in: 'Trade in',
  make_and_model: 'Make & Model',
  last_name: 'Last name',
  phone: 'Phone',
  message: 'Message',

  pricing: 'Pricing',
  pricing_description:
    'Set the pricing information for this vehicle in order to help your customers to make the best choice.',
  public: 'Public',
  pricing_public_description:
    'Prices visible to customers on your website and external listings.',
  internal: 'Internal',
  pricing_internal_description:
    'Internal pricing used for your team and financial planning.',

  retail_price: 'Retail price',
  anchor_price: 'MSRP',
  anchor_price_short: 'MSRP',
  internet_price: 'Internet price',
  on_sale_price: 'On sale price',
  vehicle_cost_price: 'Vehicle cost price',
  market_price: 'Market price',
  reserve_price: 'Reserve price',
  discounted_price: 'Discounted price',

  costs: 'Costs',
  costs_description:
    'Enter and track all acquisition, transportation, preparation, and tax costs associated with a vehicle. Keeping this information accurate helps in financial planning and pricing strategies.',
  actions: 'Actions',
  name: 'Name',
  supplier: 'Supplier',
  price: 'Price',
  payment_type: 'Payment type',

  category: 'Category',
  invalid_category: 'Invalid category',
  category_placeholder: 'Select category',

  name_placeholder: 'Enter name',
  invalid_name: 'Invalid name',

  invalid_supplier: 'Invalid supplier',
  supplier_placeholder: 'Select supplier',

  payment_method: 'Payment method',
  invalid_payment_method: 'Invalid payment method',
  payment_method_placeholder: 'Select payment method',

  invalid_date: 'Invalid date',
  date_placeholder: 'Enter date',

  ref_number: 'Ref. number',
  invalid_ref_number: 'Invalid ref. number',
  ref_number_placeholder: 'Enter ref. number',

  payment_status: 'Payment status',
  invalid_payment_status: 'Invalid payment status',
  payment_status_placeholder: 'Select payment status',

  receipt: 'Receipt',
  upload_receipt: 'Upload receipt',
  upload_receipt_placeholder: 'Upload receipt',
  invalid_upload_receipt: 'Invalid receipt',
  invalid_recepit: 'Invalid recepit',
  recepit_placeholder: 'Enter recepit',

  invalid_costs: 'Invalid costs',
  costs_placeholder: 'Select costs',
  add_cost: 'Add cost',
  add_pack: 'Add pack',
  add_package: 'Add package',

  package: 'Package',
  package_placeholder: 'Select package',
  invalid_package: 'Invalid package',
  package_added: 'Package added to the vehicle',

  category_Transportation: 'Transportation',
  category_Accessories: 'Accessories',
  category_Maintenance: 'Maintenance',
  category_Fees: 'Fees',
  category_Charges: 'Charges',
  category_Assessment: 'Assessment',
  category_Duties: 'Duties',
  category_Levies: 'Levies',
  empty_vin_warning: 'The VIN does not contain additional information',
  vin_updated: 'The vehicle VIN was updated',
  vin_updated_media_error:
    'The vehicle VIN was updated but some media could not be properly updated',

  saving_text: 'Saving...',
  all_changes_saved: 'All changes have been saved',

  acquisition_title: 'Acquisition',
  acquisition_description:
    "Enter key details about the vehicle's purchase, including price and book value. Keeping this information accurate helps maintain clear records.",
  purchased_at_auction: 'Auction',
  purchased_at_bank_auction: 'Bank auction',
  purchased_at_private_seller: 'Private seller',
  purchased_at_trade_in: 'Trade-in',

  purchased_at: 'Purchase source',
  purchased_at_placeholder: 'Enter purchase source',
  invalid_purchased_at: 'Invalid purchase source',

  purchase_date: 'Purchase date',
  purchase_price: 'Purchase price',
  book_value: 'Book value',

  lien_title: 'Lien',
  lien_description:
    "Provide information about the vehicle's lien, including the bank, balance, and repayment details. Accurate records ensure a smooth financial process.",

  lien_institution: 'Lien institution',
  lien_institution_placeholder: 'Select lien institution',
  invalid_lien_institution: 'Invalid lien institution',

  lien_amount: 'Lien amount',
  balance: 'Balance',
  call_payment: 'Call payment',
  payment_start_date: 'Payment start date',
  paid_percentage: 'Paid percentage',
  paid_percentage_placeholder: 'Enter paid percentage',
  invalid_paid_percentage: 'Invalid paid percentage',
  repayment_start_date: 'Repayment start date',
  bank_duties: 'Bank duties',

  registration_plate_number_status: 'License plate status',
  registration_plate_number_status_placeholder: 'Select registration plate number status',
  invalid_registration_plate_number_status: 'Invalid registration plate number status',
  pending: 'Pending',
  received: 'Received',
  assigned: 'Assigned',
  canceled: 'Canceled',
  rejected: 'Rejected',
  in_process: 'In process',

  carfax: 'Carfax',
  carfax_placeholder: 'Enter Carfax',
  invalid_carfax: 'Invalid Carfax',

  complete: 'Complete',
  complete_placeholder: 'Enter complete',
  invalid_complete: 'Invalid complete',

  start_deal: 'Start deal',
  go_to_deal: 'Go to deal',
  download_qr: 'Download QR',

  share_vehicle: 'Share vehicle',
  share: 'Share',
  generate: 'Generate',
  regenerate: 'Regenerate',
  content_length: 'Content length',
  content_length_short: 'Short',
  content_length_standard: 'Standard',
  content_length_long: 'Long',
  language: 'Language',
  language_es: 'Español',
  language_en: 'English',
  additional_instructions: 'Additional instructions',
  additional_instructions_placeholder: 'Enter additional instructions',
  generated_post: 'Generated post',
  edit_text: 'Edit text',
  copy_text: 'Copy text',
  post_text_copied: 'Post text successfully copied!',

  select_vehicle: 'Select vehicle',

  information: 'Information',
};

export default translations;
